import { render, staticRenderFns } from "./LearningItemsManager.vue?vue&type=template&id=93ba5fd2&scoped=true&"
import script from "./LearningItemsManager.vue?vue&type=script&lang=js&"
export * from "./LearningItemsManager.vue?vue&type=script&lang=js&"
import style0 from "./LearningItemsManager.vue?vue&type=style&index=0&id=93ba5fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba5fd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
